/**
 * @generated SignedSource<<48c85464b51469e16ca1722a7ceb9c40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadMessages_User$data = {
  readonly email: string | null | undefined;
  readonly integrationName: string | null | undefined;
  readonly unconfirmedEmail: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsGuest">;
  readonly " $fragmentType": "ChatThreadMessages_User";
};
export type ChatThreadMessages_User$key = {
  readonly " $data"?: ChatThreadMessages_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadMessages_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unconfirmedEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ab87cc097321e9ad1bb5f83fb1c5560e";

export default node;
